<template>
    <div class="panel_users">
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="table-area">
                        <div class="widget-title">
                            <h3><i :class="icon"> </i> {{ tableName }}</h3>
                            <span>{{ tableDesc }}</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Ad Soyad</th>
                                        <th>E-mail</th>
                                        <th>İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in items" :key="item.id">
                                        <td>{{ item.first_name }} {{ item.last_name }}</td>
                                        <td>{{ item.email }}</td>
                                        <td>
                                            <router-link :to="{ name: 'panel_users.update', params: {id: item.id} }" class="btn btn-primary btn-xs"> <span>Düzenle</span></router-link> / <button class="btn btn-danger btn-xs"> Sil</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                icon: 'fa fa-users',
                tableName: 'Panel Kullanıcı Tablosu',
                tableDesc: '',
                api: 'panel_users',
                items: [],
            }
        },

        methods: {
            getData() {
                this.$Progress.start()
                this.axios.get(this.api)
                    .then(response => {
                        this.items = response.data
                        this.$Progress.finish()
                    })
                    // eslint-disable-next-line no-unused-vars
                    .catch(error => {
                        // console.log(error.response.data);
                    });
            },
        },
        mounted() {
            this.getData();
        },
    }
</script>

<style scoped>

</style>
